// extracted by mini-css-extract-plugin
export default {"root":"zS8yv5","textAvatar":"EJYIOZ","anonymousAvatar":"JdvX72"};